var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-wrapper g-vertical-block"},[_c('div',{staticClass:"g-main-wrapper g-vertical-block"},[_c('keep-alive',{attrs:{"max":10}},[_c('router-view',{key:_vm.$route.path})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }